import { HelperText } from '../../utils/translations';
import { ImageObjectId } from '../../objects';

export enum FormsAttributes {
  API_KEY = 'apiKey',
  MAIL_LOGO = 'mailLogo',
  MAIL_FOOTER = 'mailFooter',
}

export const formsAttributes = {
  [FormsAttributes.API_KEY]: {
    title: HelperText.FORM_API_KEY,
    description: HelperText.FORM_API_KEY_DESCRIPTION,
  },
  [FormsAttributes.MAIL_LOGO]: {
    title: HelperText.MAIL_LOGO,
    description: HelperText.MAIL_LOGO_DESCRIPTION,
  },
  [FormsAttributes.MAIL_FOOTER]: {
    title: HelperText.MAIL_FOOTER,
    description: HelperText.MAIL_FOOTER_DESCRIPTION,
  },
};

export const formsClassAttributes = {
  [FormsAttributes.API_KEY]: 'string',
  [FormsAttributes.MAIL_LOGO]: ['reference', { only: [ImageObjectId] }],
  [FormsAttributes.MAIL_FOOTER]: 'html',
};
